import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { UserGuard } from '../guards/UserGuard';
import { AdminGuard, PartnerGuard } from '../guards/RolesGuard';
import { DOMAIN } from '../config';
import ExternalRedirect from './ExternalRedirect';


export type RouteWrapperProps = {
    guard?: () => boolean;
    redirectPath?: string;
    element: JSX.Element;
};

export default function RouteWrapper({ guard, redirectPath, element }: RouteWrapperProps) {
    const location = useLocation();
    const redirectNotExistingRoutes = UserGuard() ? ((AdminGuard() || PartnerGuard()) ? '/insights' : DOMAIN || '/login') : DOMAIN || '/login'
    const redirect = redirectPath || redirectNotExistingRoutes || DOMAIN || '/login';
	const isExternal = redirect?.startsWith('http'); // Check if external
	console.log({isExternal})

    if ((guard && guard()) || location.pathname === redirect || guard === undefined) {
        return <React.Fragment>{element}</React.Fragment>;
    } else {
        return (
            <React.Fragment>
                {isExternal ? <ExternalRedirect url={redirect} /> : <Navigate to={{ pathname: redirect }} />}
            </React.Fragment>
        );
    }
}
